
import {ROOT} from "./root";

// @todo: separate into default mappings and downloadable mappings
export default (function()
{
	const o	=	ROOT;

	{
	o.queryTrie	=	Object.create(o.bangTrie.prototypeObject);

	// load and handle bang definitions CSV file
	// disable for now
	// o.xhrText(o.csvUrl);

	var ctx	=	{
		to: -1
		,timeout: 256
		,bangTrie: o.bangTrie
		,queryTrie: o.queryTrie
		,queries: o.queries
		,names: o.names
		,categories: o.categories
		,duckUrls: o.duckUrls
		,queryRegexpToReplace: o.queryRegexpToReplace
		,defaultSearchEngineQuery: o.defaultSearchEngineQuery
		,groupSearchSeparator: o.groupSearchSeparator
		,maxShownSuggestions: o.maxShownSuggestions
		,bangStartCharacter: o.bangStartCharacterReplacement || o.bangStartCharacter || ''
		,showPartialMatchBangs: o.showPartialMatchBangs
		,showPartialMatchUrls: o.showPartialMatchUrls
		,log: o.log
		,openLink: o.openLink.bind(null)
	};
	ctx.csvParser	=	o.csvParser.bind(ctx);
	ctx.onEnter		=	o.onenter.bind(ctx);
	ctx.onInput		=	o.onChange.bind(ctx);
	ctx.onCsvParse	=	o.onCsvParse.bind(o);
	}



	// @note: ripped from modified surfingkeys config
	{
	// Searches
	// Mappings with 's' and 'o' prefixes also will be taken
	// @todo: registered key sequences are free for mapping, must decide if it should be so
	var googleSearchQ = "https://www.google.com/search?q=",
	googleSearchBase = googleSearchQ + "{0}",
	googleSearchHistory =
	"https://myactivity.google.com/myactivity?authuser=0&q={0}",
	tStr = googleSearchBase + "&tbs=qdr:",
	googleImages =
	"https://www.google.com/search?q={0}&sxsrf=ALeKk009TUWmnI1QbFWPVq4D4qrIZgdo2w:1607544914807&source=lnms&tbm=isch&sa=X&ved=2ahUKEwiu0-2828HtAhWMslkKHT5qALgQ_AUoAXoECBQQAw&biw=1745&bih=916",
	// hackernews
	hackernewsBase = "https://hn.algolia.com/?q={0}&page=0&prefix=false",
	hnTStr = hackernewsBase + "&dateRange=",
	// product hunt
	producthuntBase = "https://www.producthunt.com/search?q={0}",
	phTStr = producthuntBase + "&postedDate=",
	//code reference
	mdnBase = "https://developer.mozilla.org/en-US/search?q={0}",
	devdocBase = "http://devdocs.io/#q={0}",
	// github code
	githubBaseRepo = "https://github.com/search?q={0}&type=repositories",
	githubBaseCode = "https://github.com/search?o=desc&q={0}&s=&type=Code",
	githubBaseCommits = "https://github.com/search?q={0}&type=commits",
	githubBaseIssues = "https://github.com/search?q={0}&type=issues",
	githubBaseDiscussions = "https://github.com/search?q={0}&type=discussions",
	githubBaseRegistrypackages =
	"https://github.com/search?q={0}&type=registrypackages",
	githubBaseMarketplace = "https://github.com/search?q={0}&type=marketplace",
	githubBaseTopics = "https://github.com/search?q={0}&type=topics",
	githubBaseWikis = "https://github.com/search?q={0}&type=wikis",
	githubBaseUsers = "https://github.com/search?q={0}&type=users",
	gmailBase = "https://mail.google.com/mail/u/0/#search/{0}",
	// youtube
	youtubeBase = "https://www.youtube.com/results?search_query={0}",
	youtubeChannel = youtubeBase + "&sp=EgIQAg%253D%253D",
	youtubePlaylist = youtubeBase + "&sp=EgIQAw%253D%253D",
	youtubeMovie = youtubeBase + "&sp=EgIQBA%253D%253D",
	youtubeShow = youtubeBase + "&sp=EgIQBQ%253D%253D",
	youtubeShort = youtubeBase + "&sp=EgIYAQ%253D%253D",
	youtubeLong = youtubeBase + "&sp=EgIYAg%253D%253D",
	youtubeLive = youtubeBase + "&sp=EgJAAQ%253D%253D",
	youtube4k = youtubeBase + "&sp=EgJwAQ%253D%253D",
	youtubeHD = youtubeBase + "&sp=EgIgAQ%253D%253D",
	youtubeSubtitles = youtubeBase + "&sp=EgIoAQ%253D%253D",
	youtubeCreativeCommons = youtubeBase + "&sp=EgIwAQ%253D%253D",
	youtube360 = youtubeBase + "&sp=EgJ4AQ%253D%253D",
	youtubeVR = youtubeBase + "&sp=EgPQAQE%253D",
	youtube3d = youtubeBase + "&sp=EgI4AQ%253D%253D",
	youtubeHDR = youtubeBase + "&sp=EgPIAQE%253D",
	youtubeLocation = youtubeBase + "&sp=EgO4AQE%253D",
	youtubePurchased = youtubeBase + "&sp=EgJIAQ%253D%253D",
	youtubeUploadDate = youtubeBase + "&sp=CAI%253D",
	youtubeViewCount = youtubeBase + "&sp=CAM%253D",
	youtubeRating = youtubeBase + "&sp=CAE%253D",
	youtubeHistory = "https://www.youtube.com/feed/history?query={0}",
	// web design
	creativemarketBase = "https://creativemarket.com/search?q={0}",
	elementsenvatoBase = "https://elements.envato.com/all-items/{0}",
	behanceBase = "https://www.behance.net/search?search={0}",
	dribbleBase = "https://dribbble.com/search/{0}",
	awwardsBase = "https://www.awwwards.com/inspiration/search?text={0}",
	uisourcesBase = "https://www.uisources.com/search?query={0}",
	searchmuzliBase = "https://search.muz.li/search/{0}",
	pinterestBase = "https://www.pinterest.com/search/pins/?q={0}",
	// key: [name, query]
	searches = {
		// search
		dcm: ["creative market", creativemarketBase],
		dee: ["envato elements", elementsenvatoBase],
		db: ["behance", behanceBase],
		dd: ["dribble", dribbleBase],
		daw: ["awwards", awwardsBase],
		dui: ["uisources", uisourcesBase],
		dm: ["muzli", searchmuzliBase],
		dp: ["pinterest", pinterestBase],

		Y: ["youtube search", youtubeBase],
		yy: ["youtube year", youtubeBase + "&sp=EgIIBQ%253D%253D"],
		ym: ["youtube month", youtubeBase + "&sp=EgQIBBAB"],
		yw: ["youtube week", youtubeBase + "&sp=EgQIAxAB"],
		yd: ["youtube day", youtubeBase + "&sp=EgQIAhAB"],
		yh: ["youtube hour", youtubeBase + "&sp=EgQIARAB"],
		yH: ["youtube history", youtubeHistory],
		yc: ["youtube channel", youtubeChannel],
		yp: ["youtube Playlist", youtubePlaylist],
		yM: ["youtube Movie", youtubeMovie],
		ySh: ["youtube Show", youtubeShow],
		ys: ["youtube Short", youtubeShort],
		ylo: ["youtube Long", youtubeLong],
		yli: ["youtubeLive", youtubeLive],
		y4k: ["youtube4k", youtube4k],
		yHD: ["youtubeHD", youtubeHD],
		ySu: ["youtubeSubtitles", youtubeSubtitles],
		yCC: ["youtubeCreativeCommons", youtubeCreativeCommons],
		y360: ["youtube360", youtube360],
		yvr: ["youtubeVR", youtubeVR],
		y3d: ["youtube3d", youtube3d],
		yHDR: ["youtubeHDR", youtubeHDR],
		yL: ["youtubeLocation", youtubeLocation],
		yP: ["youtubePurchased", youtubePurchased],
		yu: ["youtubeUploadDate", youtubeUploadDate],
		uvc: ["youtubeViewCount", youtubeViewCount],
		yr: ["youtubeRating", youtubeRating],

		i: ["gmail search", gmailBase],

		pH: ["product hunt", producthuntBase],
		phy: ["product hunt year", phTStr + "12%3Amonths"],
		ph3m: ["product hunt year", phTStr + "90%3Adays"],
		phm: ["product hunt year", phTStr + "30%3Adays"],

		hN: ["hacker news", hackernewsBase],
		hny: ["hacker news year", hnTStr + "pastYear"],
		hnm: ["hacker news month", hnTStr + "pastMonth"],
		hnw: ["hacker news week", hnTStr + "pastWeek"],
		hnd: ["hacker news day", hnTStr + "last24h"],

		gH: ["github", githubBaseRepo],
		ghc: ["github", githubBaseCode],
		ghC: ["github", githubBaseCommits],
		ghi: ["github", githubBaseIssues],
		ghd: ["github", githubBaseDiscussions],
		ghr: ["github", githubBaseRegistrypackages],
		ghm: ["github", githubBaseMarketplace],
		ght: ["github", githubBaseTopics],
		ghw: ["github", githubBaseWikis],
		ghu: ["github", githubBaseUsers],

		//code reference
		crm: ["code reference mdn", mdnBase],
		crdd: ["code reference devdoc", devdocBase],

		G: ["Google", googleSearchBase],
		gm: ["googlemonth", tStr + "m"],
		gw: ["googleweek", tStr + "w"],
		gy: ["googleyear", tStr + "y"],
		gd: ["googleday", tStr + "d"],
		gH: ["googlehour", tStr + "h"],
		gsh: ["google search history", googleSearchHistory],
		gi: ["google images", googleImages],

		// conflict, changed from l to ll
		ll: ["lucky", googleSearchBase + "&btnI"],
		// conflict, changed from t to tt
		tt: ["onelook", "https://www.onelook.com/?w={0}&ls=a"],
		s: ["onelook synonyms", "https://www.onelook.com/thesaurus/?s={0}"],
		D: [
			"google drive search",
			"https://drive.google.com/drive/u/1/search?q={0}",
		],
		// conflict, changed from c to cc
		cc: ["technical translation", "https://techterms.com/definition/{0}"],
		// conflict, changed from w to ww to wk
		wk: ["wiki", "https://en.wikipedia.org/wiki/{0}"],

		//map
		gM: ["google maps", "https://www.google.com/maps?q="],

		//coding
		C: ["search coding", "https://searchcode.com/?q="],
		cC: ["search coding", "https://searchcode.com/?q="],
		cw: ["chrome webstore", "https://chrome.google.com/webstore/search/"], // chrome
		cS: ["slant (editor 비교 사이트)", "https://www.slant.co/search?query="],
		gH: ["github", "https://github.com/search?q="],

		//language
		lJ: ["language Javascript", googleSearchQ + "Javascript+"],
		lj: ["language java", googleSearchQ + "Java+"],
		lC: ["C++", googleSearchQ + "C++"],
		lc: ["language c", googleSearchQ + "c+language+"],
		"l#": ["language C#", googleSearchQ + "c%23+"],
		lR: ["language R", googleSearchQ + "languag+"],
		lr: ["language Ruby", googleSearchQ + "Ruby+"],
		lP: ["language Python", googleSearchQ + "Python+"],
		lp: ["language php", googleSearchQ + "php+"],
		lK: ["language Kotlin", googleSearchQ + "Kotlin+"],
		lS: ["language Swift", googleSearchQ + "Swift+"],
		lQ: ["language SQL Query", googleSearchQ + "SQL+"],
		ls: ["language Shell script", googleSearchQ + "Shell+Schript+"],
		lT: ["language Typescript", googleSearchQ + "TypeScript+"],
		lH: ["language HTML", googleSearchQ + "HTML+"],

		//sns
		fb: ["faceBook(페이스북)", "https://www.facebook.com/search/top/?q="],
		tw: ["tWitter", "https://twitter.com/search?q="],
		ig: ["InstaGram HashTag", "https://www.instagram.com/explore/tags/"],
		rd: ["redDit", "https://www.reddit.com/search?q="],

		//shorten - what is.. who is.. where is..
		wa: ["advanced", googleSearchQ + "advanced+"],
		wb: ["basic", googleSearchQ + "basic+"],
		wc: ["classification", googleSearchQ + "classfication+of+"],
		wd: ["difference", googleSearchQ + "difference+between+"],
		we: ["example", googleSearchQ + "example+of+"],
		ww: ["wherefrom", googleSearchQ + "where+from+"],
		wg: ["goalof", googleSearchQ + "what+is+goal+of+"],
		wh: ["historyof", googleSearchQ + "history+of+"],
		wi: ["introductionof", googleSearchQ + "Introduction+of"],

		//file
		pdf: ["fppdf", googleSearchQ + "filetype%3Apdf+"],
		cpp: ["fpcpp", googleSearchQ + "filetype%3Acpp+"],
		hwp: ["fphwp", googleSearchQ + "filetype%3Ahwp+"],
		ppt: ["fpppt", googleSearchQ + "filetype%3Appt+"],
	},
	// only 's' and 'o' prefixed mappings will be taken
	searchGroups = {
		0: {
			name: "Social networks searches",
			list: ["fb", "tw", "ig", "rd"],
		},
		gg: {
			name: "Google group searches",
			list: ["G", "gy", "gm", "gw", "gd", "gH"],
		},
		ghg: {
			name: "Github group",
			list: [
			"gH",
			"ghc",
			"ghC",
			"ghi",
			"ghd",
			"ghr",
			"ghm",
			"ght",
			"ghw",
			"ghu",
			],
		},
		hnc: {
			name: "Hacker News Combined",
			list: ["hN", "hny", "hnm", "hnw", "hnd"],
		},
		phc: {
			name: "Product Hunt Combined",
			list: ["phy", "ph3m", "phm"],
		},
		cpy: {
			name: "combined product search by year",
			list: ["gy", "hny", "phy", "yy", "gH"],
		},
		cpm: {
			name: "combined product search by month",
			list: ["gm", "hnm", "phy", "ym", "gH"],
		},
		cpd: {
			name: "combined product search by day",
			list: ["gd", "hnd", "phm", "yd", "gH"],
		},
		cd: {
			name: "combined design",
			list: ["dcm", "db", "dee", "dd", "daw", "dui", "dm", "dp"],
		}
	},
	searchCategory		=	'Search',
	groupSearchCategory	=	'Combined-Search',
	_parsedCsv	=	[[/* header */]],
	_tmp;


	// register mappings for searches
	for (var k in searches) {
		_tmp					=	[];
		_tmp[o.bangIndex]		=	k;
		_tmp[o.nameIndex]		=	searches[k][0];
		_tmp[o.queryIndex]		=	searches[k][1];
		_tmp[o.duckUrlIndex]	=	'';
		_tmp[o.categoryIndex]	=	searchCategory;

		// push into 'parsed csv' array
		_parsedCsv.push(_tmp);
	}

	// register mappings for search groups
	for (var k in searchGroups) {
		_tmp					=	[];
		_tmp[o.bangIndex]		=	k;
		_tmp[o.nameIndex]		=	searchGroups[k].name;
		_tmp[o.queryIndex]		=	'';
		_tmp[o.duckUrlIndex]	=	'';
		_tmp[o.categoryIndex]	=	groupSearchCategory;

		for (var i = 0; i < searchGroups[k].list.length; i++){
			if (_tmp[o.queryIndex]){
				_tmp[o.queryIndex]	+=	o.groupSearchSeparator + searches[searchGroups[k].list[i]][1];
			} else {
				_tmp[o.queryIndex]	=	searches[searchGroups[k].list[i]][1];
			}
		}

		// simplify job for group search
		searches[k]	=	_tmp;

		// push into 'parsed csv' array
		_parsedCsv.push(_tmp);
	}

	// add 'bangs' from 'parsed csv' array
	ctx.onCsvParse(_parsedCsv, true);

	}



	return ctx;
})();
